module.exports = __webpack_public_path__ + "assets/img/bg_scan.cd07a125.png";